import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { classNames } from "primereact/utils";
import { useSelector } from "react-redux";
import { AuthContext } from "../../../../Header/auth - context";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Loading from "../../../../Loading/loading";
import useVisinaTabele from "../../../../custom/visinaTabele";

import "../../magacin_basic.css";
import "../../magacin.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const PregledZaliha = () => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);

  const [tableData, setTableData] = useState([]);
  const [mag, setMag] = useState([]);
  const [dropMag, setDropMag] = useState(null);
  const [gume, setGume] = useState(false);

  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  /* Broj redova po strani bira korisnik; 25 je polazno. */
  const [redovaPoStrani, setRedovaPoStrani] = useState(25);
  const [load, setLoad] = useState(true);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

  const handleErrors = (response) => {
    if (response.ok) return response.json();
    throw response;
  };

  const getConfigColumns = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 332
      }),
    };

    const data = await fetch(
      process.env.REACT_APP_BACKEND_URL + "/config/",
      requestOptions
    ).then(handleErrors);

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Greška",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

    if (data.length > 0) {
      return { empty: false, data };
    }

    return { empty: true, data: [] };
  };

  useEffect(() => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/part/warehouse", requestOptions)
      .then(handleErrors)
      .then((result) => {
        const warehouse = result.map((ware) => ({
          label: ware.magacin,
          value: ware.id,
        }));

        setMag(warehouse);
        setLoad(false);
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Greška",
            detail: errorMessage.message,
            life: 3000,
          });
        });
        setLoad(false);
      });
  }, [auth.token, company.companyId]);

  const getSpecificWarehousePartData = async (value, isGume) => {
    setDropMag(value);
    setLoad(true);

    const useGume = isGume !== undefined ? isGume : gume;

    if (useGume) {
      fetch(process.env.REACT_APP_BACKEND_URL + "/warehouse/GetGumaZaliha", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
        body: JSON.stringify({ id_magacin: value }),
      })
        .then(handleErrors)
        .then((result) => {
          setTableData(result || []);
          if (result && result.length > 0) {
            const columns = Object.keys(result[0]).map((key) => ({ label: key, value: key }));
            setAllColumns(columns);
            setOriginalColumnOrder(Object.keys(result[0]));
            setSelectedColumns(Object.keys(result[0]));
          } else {
            setAllColumns([]);
            setSelectedColumns([]);
            setOriginalColumnOrder([]);
          }
          setLoad(false);
        })
        .catch((error) => {
          error.json?.().then((errorMessage) => {
            toast.current.show({ severity: "error", summary: "Greška", detail: errorMessage.message, life: 3000 });
          });
          setLoad(false);
        });
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        firma_id: company.companyId,
        warehouse_id: value,
      }),
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/part/magacin", requestOptions)
      .then(handleErrors)
      .then(async (result) => {
        setTableData(result || []);

        if (result && result.length > 0) {
          const columns = Object.keys(result[0]).map((key) => ({
            label: key,
            value: key,
          }));

          setAllColumns(columns);
          const originalOrder = Object.keys(result[0]);
          setOriginalColumnOrder(originalOrder);

          const columnsDB = await getConfigColumns();

          if (!columnsDB.empty && columnsDB.data.length > 0) {
            const arr = JSON.parse(columnsDB.data[0].parametri);
            setSelectedColumns(arr);
          } else {
            setSelectedColumns(originalOrder.slice(0, 8));
          }
        } else {
          setAllColumns([]);
          setSelectedColumns([]);
          setOriginalColumnOrder([]);
        }

        setLoad(false);
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Greška",
            detail: errorMessage.message,
            life: 3000,
          });
        });
        setLoad(false);
      });
  };

  const rowClassName = (rowData) => {
    const qty = Number(rowData.kolicina ?? rowData.Količina ?? 0);
    const classes = [];

    /* Nula i minus nisu ista stvar: nula znači „sve je izdato", a minus da
       je negde pogrešno knjiženo — pa se i vidi jače. */
    if (qty < 0) classes.push("row-outofstock", "row-negativna");
    else if (qty === 0) classes.push("row-outofstock");
    else if (qty > 0 && qty < 6) classes.push("row-red");
    else if (qty >= 6 && qty < 11) classes.push("row-yellow");

    return classes.join(" ");
  };

  const stockBodyTemplate = (rowData) => {
    const qty = Number(rowData.kolicina ?? rowData.Količina ?? 0);

    const stockClassName = classNames({
      outofstock: qty <= 0,
      verylowstock: qty > 0 && qty < 6,
      lowstock: qty >= 6 && qty < 11,
      instock: qty >= 11,
    });

    return <div className={stockClassName}>{qty}</div>;
  };

  const getBodyTemplate = (colKey, rowData) => {
    const lower = colKey.toLowerCase();

    if (lower === "kolicina" || lower === "quantity") {
      return stockBodyTemplate(rowData);
    }

    return rowData[colKey] ?? "-";
  };

  const exportExcel = async () => {
    if (!selectedColumns || selectedColumns.length === 0 || !tableData?.length) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje",
        detail: "Nema podataka za export.",
        life: 3000,
      });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Pregled zaliha");

    const headers = selectedColumns;

    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEFEFEF" },
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    tableData.forEach((rowData) => {
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    worksheet.columns.forEach((column, i) => {
      const lengths = [
        headers[i]?.length || 10,
        ...tableData.map((row) => (row[headers[i]] ?? "").toString().length),
      ];
      column.width = Math.min(Math.max(...lengths) + 2, 40);
    });

    const date = new Date();
    const serbianDateTime = date
      .toLocaleString("sr-RS", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Europe/Belgrade",
      })
      .replace(/,/g, "");

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      blob,
      `Pregled zaliha - ${company.companyName} - ${serbianDateTime}.xlsx`
    );
  };

  const handleSaveConfig = () => {
    confirmDialog({
      message: "Da li ste sigurni da želite sačuvati konfiguraciju?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptInsertConfig,
    });
  };

  const acceptInsertConfig = () => {
    if (!selectedColumns.length) {
      toast.current.show({
        severity: "warn",
        summary: "Upozorenje",
        detail: "Morate imati barem 1 izabranu kolonu.",
        life: 3000,
      });
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 332,
        parametri: selectedColumns,
      }),
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/config/changeConfig",
      requestOptions
    )
      .then(handleErrors)
      .then((data) => {
        if (
          data.message &&
          data.message === "Nema izmena u podacima konfiguracije pregleda."
        ) {
          toast.current.show({
            severity: "warn",
            summary: "Upozorenje",
            detail: data.message,
            life: 3000,
          });
          return;
        }

        toast.current.show({
          severity: "success",
          summary: "Uspešno",
          detail: "Konfiguracija pregleda zaliha je sačuvana.",
          life: 3000,
        });
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Greška",
            detail: errorMessage.message,
            life: 3000,
          });
        });
      });
  };

  const handleGumeToggle = (checked) => {
    setGume(checked);
    setTableData([]);
    setAllColumns([]);
    setSelectedColumns([]);
    setOriginalColumnOrder([]);
    if (dropMag) getSpecificWarehousePartData(dropMag, checked);
  };

  const header = (
    /* Levo alatke i izbor kolona, desno pretraga — isti raspored kao u
       pregledima u Administraciji, da operater ne traži pretragu na dva
       različita mesta zavisno od modula. */
    <div className="export-buttons fakture-stavke-header">

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
        <Button
          type="button"
          icon="pi pi-file-excel"
          severity="success"
          rounded
          onClick={exportExcel}
          data-pr-tooltip="XLS"
        />
        <Dropdown
          value={dropMag}
          options={mag}
          onChange={(e) => getSpecificWarehousePartData(e.value)}
          placeholder={t('nova.phMagacin')}
          className="magacin"
          style={{ minWidth: 'fit-content' }}
        />
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer', fontWeight: 500 }}>
          <input
            type="checkbox"
            checked={gume}
            onChange={(e) => handleGumeToggle(e.target.checked)}
            style={{ width: 16, height: 16, cursor: 'pointer' }}
          />
          Gume
        </label>

        {allColumns.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MultiSelect
              value={selectedColumns}
              options={allColumns}
              onChange={(e) => {
                const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
                setSelectedColumns(sorted);
              }}
              optionLabel="label"
              display="chip"
              placeholder={t('nova.odaberiteKolone')}
              style={{ minWidth: '14rem' }}
              showSelectAll={true}
              filter
              filterPlaceholder="Pretraži kolone"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} kolona odabrano"
            />
            <button onClick={handleSaveConfig} style={{ marginLeft: '0.3rem' }} className="configSaveButton">
              <i className="pi pi-save"></i>
            </button>
          </div>
        )}
      </div>

      <input
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value.replace(/s+/g, ' ').trimStart())}
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
      />
    </div>
  );
  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <ConfirmDialog />
      {load && <Loading />}

      <Tooltip target=".export-buttons>button" position="bottom" />

      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaPoStrani}
        rowsPerPageOptions={[redovaTabele, 50, 100]}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => { setFirst(e.first); setRedovaPoStrani(e.rows); }}
        scrollable
        header={header}
        /* Telo ide po visini ekrana, ne fiksnih 600px: tako paginator ostaje
           vidljiv i skroluje se PO TABELI, a ne cela stranica. */
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={load}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={rowClassName}
      >
        {selectedColumns.map((colKey) => {
          const colMeta = allColumns.find((col) => col.value === colKey);

          return (
            <Column
              key={colKey}
              field={colKey}
              header={colMeta?.label || colKey}
              sortable
              body={(rowData) => getBodyTemplate(colKey, rowData)}
              style={{ minWidth: "150px" }}
            />
          );
        })}
      </DataTable>
      </div>
    </div>
  );
};

export default PregledZaliha;